import React, { useEffect } from 'react'
import { Row, Col } from 'react-bootstrap';
import { FormField } from 'uiwidgets/FormField';
import {
    containsAlphaNumAndSpaceOnly, validAddress, doesStringHaveSpecialChars,
    isValidDate, isDateGreaterThanToday, isPostalCodeValid, containsAlphaNumAndSpaceAndPunctuationOnly
} from "../../util/Validators";
import { arrayRange } from 'util/NumberUtils';
import CountrySelect from 'uiwidgets/CountrySelect';
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import PostalCode from 'uiwidgets/PostalCode';


const EventRecipient = (props) => {
    let { formData, setFormData, formValidityData, setFormValidityData, recipientValidationFunction } = props;

    useEffect(() => {
        recipientValidationFunction.current = validateInput;
        setFormData({
            ...formData,
            sponsorshipAttributes: {
                country: 'CA',
                state: 'ON'
            }
        })
    }, [])

    const handleChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        if (name === 'spcode') {
            setFormData({
                ...formData,
                sponsorshipKey: value,
                sponsorshipAttributes: {
                    ...formData.sponsorshipAttributes,
                    [name]: value
                }
            })

        } else {
            setFormData({
                ...formData,
                sponsorshipAttributes: {
                    ...formData.sponsorshipAttributes,
                    [name]: value
                }
            })
        }
    }

    const handleCountryChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let defaultState = "ON";
        if (value === "US") {
            defaultState = "MI";
        }
        setFormData({
            ...formData,
            sponsorshipAttributes: {
                ...formData.sponsorshipAttributes,
                [name]: value,
                state: defaultState
            }
        })
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }
    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "spcode":
                if (value.trim() === "") {
                    hasError = true
                    error = "Sponsorship Code cannot be empty"
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid Sponsorship Code. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "occassion":
                if (value.trim() === "") {
                    hasError = true
                    error = "Occassion name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Occassion Name. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "address":
                if (value.trim() === "") {
                    hasError = true
                    error = "Address name cannot be empty"
                } else if (!validAddress(value)) {
                    hasError = true
                    error = "Invalid Address"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "city":
                if (value.trim() === "") {
                    hasError = true
                    error = "City name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "City name can only contain alpha numeric characters";
                } else if (doesStringHaveSpecialChars(value)) {
                    hasError = true
                    error = "Invalid City. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "state":
                if (value.trim() === "") {
                    hasError = true
                    error = "State name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "State can only contain alpha numeric characters";
                } else if (doesStringHaveSpecialChars(value)) {
                    hasError = true
                    error = "Invalid State. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "country":
                if (value.trim() === "") {
                    hasError = true
                    error = "Country name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Country name can only contain alpha numeric characters";
                } else if (doesStringHaveSpecialChars(value)) {
                    hasError = true
                    error = "Invalid Country. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "eventDate":
                if (value.trim() === "") {
                    hasError = true
                    error = "Event Date is invalid"
                } else if (!isValidDate(value)) {
                    hasError = true
                    error = "Event Date is invalid"
                } else if (!isDateGreaterThanToday(value)) {
                    hasError = true
                    error = "Event Date must be greater than today's date"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "zip":
                if (value.trim() === "") {
                    hasError = true
                    error = "Postal Code cannot be empty"
                } else if (!isPostalCodeValid(value, formData.sponsorshipAttributes.country)) {
                    hasError = true
                    error = "Invalid Postal Code"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            default:
                break;
        }
        return { hasError, error };
    }

    return (
        <React.Fragment>
            <Row>
            <Col>
                    <FormField name="spcode" label="Sponsorship Code" type="text" value={formData.sponsorshipAttributes.spcode}
                        placeholder="Sponsorship Code" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.spcodeError} valMsg={formValidityData.spcodeErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col>
                    <FormField name="occassion" label="Occassion" type="text" value={formData.sponsorshipAttributes.occassion}
                        placeholder="occassion" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.occassionError} valMsg={formValidityData.occassionErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col>
                    <FormField name="eventDate" label="Event Date" type="date" value={formData.sponsorshipAttributes.eventDate}
                        placeholder="Event Date" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.eventDateError} valMsg={formValidityData.eventDateErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
            </Row>
            <Row>
                <Col mb={12} lg={12} sm={12}>
                    <FormField name="address" label="Address" type="text" value={formData.sponsorshipAttributes.address}
                        placeholder="Address" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
            </Row>
            <Row>
                <Col mb={4} lg={4} sm={6}>
                    <CountrySelect name="country" onChange={handleCountryChange} onBlur={handleValidation}
                        valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
                        readOnly={formData.readOnly} value={formData.sponsorshipAttributes.country || 'CA'} />
                </Col>
                <Col mb={3} lg={3} sm={6}>
                    <ProvinceSelect name="state" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
                        readOnly={formData.readOnly} value={formData.sponsorshipAttributes.state || 'ON'} country={formData.sponsorshipAttributes.country || 'CA'} />
                </Col>
            </Row>
            <Row>
                <Col mb={8} lg={8} sm={12}>
                    <FormField name="city" label="City" type="text" value={formData.sponsorshipAttributes.city}
                        placeholder="City" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col mb={4} lg={4} sm={6}>
                    <PostalCode name="zip" label="Postal Code" type="text" value={formData.sponsorshipAttributes.zip}
                        placeholder="Postal Code" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
                        readOnly={formData.readOnly} country={formData.sponsorshipAttributes.country} />
                </Col>
            </Row>


        </React.Fragment>
    )
}

export default EventRecipient